module.exports = __webpack_public_path__ + "fonts/NHaasGroteskTXPro-65Md.9bf8392.woff";